/** @format */
import styled from 'styled-components';

export const FlagWrapper = styled.span`
    display: flex;
    height: 1.6rem;
    width: 2.4rem;
`;
